export var cilMail = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M16,66V450H496V66ZM48,98H464v16L256,270,48,114ZM464,418H48V154L236.8,295.6a32.164,32.164,0,0,0,38.4,0L464,154Z' class='ci-primary'/>"];
